import dayjs from 'dayjs';

/**
 * 입력받은 일자 값을 원하는 형식으로 반환
 * @param date 일자(YYYYMMDD)
 * @param type 형식(hyphen, slash, period:기본)
 * @returns 원하는 형식으로 포맷된 전체일자
 */
function getDate(date, type) {
  const sign = type === 'hyphen' ? '-' : type === 'slash' ? '/' : '.';
  return dayjs(date).format(`YYYY${sign}MM${sign}DD`);
}

/**
 * 입력받은 일자 값을 원하는 형식으로 반환
 * @param date 일자(YYYYMMDD)
 * @param type 형식(hyphen, slash, period:기본)
 * @returns 원하는 형식으로 포맷된 년월일자
 */
function getDateYm(date, type) {
  const sign = type === 'hyphen' ? '-' : type === 'slash' ? '/' : '.';
  return dayjs(date).format(`YYYY${sign}MM`);
}

/**
 * 입력받은 일자 값들을 기간의 형식으로 반환
 * @param sdate 시작일자(YYYYMMDD)
 * @param edate 종료일자(YYYYMMDD)
 * @param type 형식(hyphen, slash, period:기본)
 * @returns 원하는 형식으로 포맷된 기간
 */
function getDateTerm(sdate, edate, type) {
  return `${getDate(sdate, type)} ~ ${getDate(edate, type)}`;
}

/**
 * 입력받은 시간 값을 포맷하여 반환
 * @param fullDate 일시(YYYYMMDDHHmm)
 * @returns 콜론(:)으로 포맷된 시간
 */
function getTime(fullDate) {
  return dayjs(fullDate).format(`HH:mm`);
}

/**
 * 입력받은 시간 값들을 기간의 형식으로 반환
 * @param fullSDate 시작일시(YYYYMMDDHHmm)
 * @param fullEDate 종료일시(YYYYMMDDHHmm)
 * @returns 콜론(:)으로 포맷된 기간
 */
function getTimeTerm(fullSDate, fullEDate) {
  return `${getTime(fullSDate)} ~ ${getTime(fullEDate)}`;
}

/**
 * 연도 목록 생성
 * @param termYear 기간햇수 (기본:100)
 * @returns 현재 년도로부터 입력받은 기간까지의 연도 목록
 */
function getYearList(termYear) {
  termYear = termYear != undefined ? Number(termYear) : 100;
  const currYear = dayjs().format('YYYY');
  const minYear = dayjs().subtract(termYear, 'year').format('YYYY');

  let yearList = [];
  for (var i = currYear; i >= minYear; i--) {
    yearList.push({
      codeNm: i.toString(),
    });
  }
  return yearList;
}

export { getDate, getDateYm, getDateTerm, getTime, getTimeTerm, getYearList };
